<!--  -->
<template>
  <div id="Home">
    <div class="carBg">
      <!-- 上侧 -->
      <div class="point1">
        <div class="inner flex flex-direction align-center">
          <div class="location text-xss"><i class="el-icon-location-outline margin-right-5"></i>{{info.stationName}}</div>
          <div class="line"></div>
          <div class="ecInfo flex justify-around align-center">
            <div class="circleMove" id="circleMove">
              <div class="circleInner flex flex-direction align-center justify-center">
                <div class="DS-font text-30 green-text">{{ChargeNum}}</div>
                <!-- 日换电次数 -->
                <div>当天换电次数</div>
              </div>
            </div>
            <div class="flex flex-direction align-center justify-around">
              <div>空闲中电池</div>
              <div class="text-xxl-xl DS-font green-text">{{battery.freeBatteryNum||0}}</div>
            </div>
            <div class="flex flex-direction align-center justify-around">
              <div>充电中电池</div>
              <div class="text-xxl-xl DS-font green-text">{{battery.chargingBatteryNum||0}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="point2">
        <div class="inner"></div>
        <div class="flex justify-around">
          <div class="ecQuantity flex flex-direction align-center">
            <div class="ecQuantityText">当天换电时长(h)</div>
            <div class="ecQuantityCounts DS-font text-xl">{{changeDatteryTime||0}}</div>
            <div class="ecQuantityPie">
              <CirclePie :cdata="cdata1" :height="'70'" :width="'70'"/>
            </div>
          </div>
          <div class="ecQuantity flex flex-direction align-center">
            <div class="ecQuantityText">当天电量(kWh)</div>
            <div class="ecQuantityCounts DS-font text-xl">{{sameElectricQuantity||0}}</div>
            <div class="ecQuantityPie">
              <CirclePie :cdata="cdata2" :height="'70'" :width="'70'"/>
            </div>
          </div>
        </div>
      </div>
      <!-- 中间 -->
      <!-- <div class="point3 flex align-center justify-center" @click="jumpToBatteryHolder"><img src="@/assets/images/site/arrow_small.png">进入充电仓</div> -->
    </div>
  </div>
</template>

<script>
  import CirclePie from '@/components/echart/circlePie'
  import { siteLeft } from '@/api/singleSite/left';
  import { dataInterface } from '@/api/dataInterfaceApi';
  let ProgressBar = require('progressbar.js')

  export default {
    name: 'home',
    components: {
      CirclePie
    },
    data() {
      return {
        cdata1: {
          text:'',
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: ['50%', '70%'],
              center:['50%','50%'],
              data: [
                {
                  value: 0,
                  itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#62DBFF" },
                      { offset: 1, color: "#3D8DFF" }
                    ])
                  }
                },
                {
                  value: 0,
                  itemStyle: {
                    opacity:0.2,
                    color:'#fff'
                  },
                },
              ],
              labelLine: {
                show: false
              },
            },
          ]   
        },
        cdata2: {
          text:'',
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: ['50%', '70%'],
              center:['50%','50%'],
              data: [
                {
                  value: 0,
                  itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#62DBFF" },
                      { offset: 1, color: "#4FFF3D" }
                    ])
                  }
                },
                {
                  value: 0,
                  itemStyle: {
                    opacity:0.2,
                    color:'#fff'
                  },
                },
              ],
              labelLine: {
                show: false
              },
            },
          ]    
        },
        info:{changePowerNum:0},
        changeDatteryTime:'',
        sameElectricQuantity:'',
        ChargeNum:'',
        battery:{freeBatteryNum:'',chargingBatteryNum:''},
      }
    },
    mounted() {
      var progressChild = new ProgressBar.Circle('#circleMove', {
          strokeWidth: 4,
          color: '#00BAB8',
          easing: 'easeInOut',
          duration: 1400,
          trailColor: '#00BAB8',
          trailWidth: 1,
          svgStyle: null

      });
      var loop = playLoop(progressChild, false)
      loop.resume();

    },
    methods: {
      changeList(val) {
        if (val.type == this.currenIndex) {
          return
        }
        this.currenIndex = val.type
      },
      getData(data) {
        this.selectStationInfo(data);
        this.getStationNum(data);
      },
    //综合态势
    selectStationInfo(data = {}) {
      let _this = this;
      // siteLeft
      //   .selectStationInfo(data)
      //   .then((res) => {
      //     if (!res) return;
      //     _this.info = res;
      //     // let hourOfPercent = res.hourOfPercent.split('%')[0];
      //     // let chargerOfPercent = res.chargerOfPercent.split('%')[0];
      //     // _this.cdata1.series[0].data[0].value = hourOfPercent;
      //     // _this.cdata1.text = hourOfPercent;
      //     // _this.cdata1.series[0].data[1].value = 100 - hourOfPercent;
      //     // _this.cdata2.series[0].data[0].value = chargerOfPercent;
      //     // _this.cdata2.text = chargerOfPercent;
      //     // _this.cdata2.series[0].data[1].value = 100 - chargerOfPercent;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

        dataInterface
        .dataFaceApiXZ({
          "enCode":"TiDB-zhandian-kongxianchongdiandianchi",
          "@station_id":data.stationId
      })
        .then((res) => {
          if (!res) return;
          _this.battery = res[0];
        })
        .catch((err) => {
          console.log(err);
        });

        
    },
    //当天换电时长
    selectChangeDatteryTime(data = {},num){
      let _this = this;
    //充电机当天换电时长
      dataInterface
        .dataFaceApiXZ({
          "enCode":"TiDB-chongdianjidangtianhuandianshichang",
          "@station_id":data.stationId
      })
        .then((res) => {
          if (!res) return;
          res = res[0];
          _this.changeDatteryTime = res.ChargeTime;
          _this.ChargeNum = res.ChargeNum;
        })
        .catch((err) => {
          console.log(err);
        });
        // 当天换电电量

        dataInterface
        .dataFaceApiXZ({
          "enCode":"TD-dangtianhuandiandianliang-new",
          "@station_id":num,
          "@ts":new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-"+new Date().getDate()+" 00:00:00"
      })
        .then((res) => {
          if (!res) return;
          _this.sameElectricQuantity = parseFloat(res[0].PowerCharge).toFixed(2)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStationNum(data={}){
      let _this = this;
      dataInterface
        .dataFaceApiXZ({
          "enCode":"genjustationidfanhuinum",
          "@station_id":data.stationId,
      })
        .then((res) => {
          if (!res) return;
          _this.selectChangeDatteryTime(data,res[0].station_num)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转到电池仓页面
    jumpToBatteryHolder(){
      //query-路由传参
      // batteryHolder?stationId=29cf1372-5bc1-4127-9a51-e260f3749ad3&batteryId=1000290070
      if( this.$route.query&&this.$route.query.stationId){
        let stationId = this.$route.query.stationId;
        let batteryId = sessionStorage.getItem('batteryId');
        let chargingWarehouseNumber = sessionStorage.getItem('chargingWarehouseNumber');
        if(window.location.href.indexOf('pcsingleSite')>-1){
          this.$router.push({
            path: '/pcbatteryHolder',
            query: {
              stationId: stationId,
              batteryId: batteryId,
              chargingWarehouseNumber: chargingWarehouseNumber,
            }
          })
        } else {
          this.$router.push({
            path: '/batteryHolder',
            query: {
              stationId: stationId,
              batteryId: batteryId,
              chargingWarehouseNumber: chargingWarehouseNumber,
            }
          })
        }
        
      } else {
        console.log("暂无站点")
      }
    }
  },
  }

function playLoop(bar) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var interval = void 0;
  var playing = false;
  function animateBar() {
      bar.animate(1, function() {
          setTimeout(function() {
              bar.animate(0)
          }, 500)
      })
  }
  function resume() {
      if (playing) {
          return
      }
      playing = true;
      interval = setInterval(function() {
          bar.set(0);
          animateBar()
      }, 4e3);
      animateBar()
  }
  if (start) {
      resume()
  }
  return {
      pause: function pause() {
          if (interval) {
              bar.stop();
              clearInterval(interval)
          }
          playing = false
      },
      resume: resume
  }
}
</script>
<style lang="scss" scoped>
  $green-text:#49FFF9;
  .green-text{
    color:$green-text;
  }
  #Home {
    width: 100%;
    height: 100%;
    position: relative;
    min-width: 2708px;
    background:url('~@/assets/images/site/bg.png');
    background-size: 100% 100%;
  }
  .carBg{
    width:1008px;
    height:416px;
    position: relative;
    top:30%;
    left:50%;
    transform: translateX(-50%);
    background:url('~@/assets/images/site/changeStation.jpg');
    background-size: 100% 100%;
  }
  .circleMove{
    position: relative;
    width:105px;
    height:105px;
    // border:6px solid $green-text;
    border-radius: 50%;
    .circleInner{
      width:90px;
      height:90px;
      position: absolute;
      background:url('~@/assets/images/site/circle_icon.png');
      background-size: 100% 100%;
      left:50%;
      top:50%;
      transform: translate(-50%,-50%);
    }
  }
  .ecInfo{
    width:100%;
    height:100%;
    padding:0 20px;
  }
  .location{
    margin:16px auto 12px;
  }
  .line{
    width:331px;
    height:1px;/*no*/
    background: #3DBCC1;
  }
  .point1,.point2,.point3{
    position:absolute;
  }
  .point1{
    width:496px;
    height:244px;
    background:url('~@/assets/images/site/point1.png');
    background-size: cover;
    top: -35%;
    right: 10%;
    .inner{
      position:absolute;
      width:396px;
      height:188px;
      left:100px;
    }
  }
  .point2{
    min-width:340px;
    min-height:146px;
    background-image: linear-gradient(180deg, rgba(14,134,139,0.88) 3%, rgba(0,43,41,0.60) 100%);
    border: 1px solid #1A7683;
    bottom:-30%;
    left: -18%;
    padding:12px 15px;
    .inner{
      width:94px;
      height:132px;
      background:url('~@/assets/images/site/point.png');
      background-size: cover;
      position: absolute;
      top:-66px;
      right:-94px;
    }
    .ecQuantityText{
      background:rgb(106, 173, 172,.6);
      padding:4px 9px;
    }
    .ecQuantityPie{
      width:70px;
      height:70px;
    }
  }
  .point3{
    // width:138px;
    // height:40px;
    background: #00BAB8;
    border-radius: 2px;
    font-size: 18px;
    font-weight:500;
    padding:8px 13px;
    top: 40%;
    left: 36%;
    cursor: pointer;
    img{
      width:16px;
      height:16px;
      margin-right:5px;
      transform:rotate(180deg);
    }
  }
  .DS-font{
    font-family:'DS-Digital-Bold'
  }

  
</style>